import React, { PureComponent } from "react";

import thinkAboutNothinAlbumCoverImage from "./norton-think-about-nothing-album-cover.jpg";

class NortonMusicPage extends PureComponent {
  render() {
    return (
      <div>
        <h1>Think About Nothing</h1>

        <div
          style={{
            margin: 5
          }}
        >
          <p>
            The album Think About Nothing was recorded by the band <i>norton</i>{" "}
            in Marshall, Minnesota in 2001.
          </p>

          <img
            alt="Think About Nothing - album by norton - 2001"
            src={thinkAboutNothinAlbumCoverImage}
            style={{
              width: "256",
              height: "auto",
              maxWidth: "256"
            }}
          />

          <p>
            Chris Haase - vocals, acoustic guitar
            <br />
            Ken Smith - vocals, duclimer, mandoline, electric and acoustic
            guitars
            <br />
            Stephen Leek - drums and percussion
            <br />
            Mark Allan - bass, vocals
            <br />
            <br />
            Additional Musicians:
            <br />
            Diane Wright - viola, violin on "Think About Nothing"
            <br />
            Jeremiah Gardner - backup vocals on "Promise"
            <br />
            <br />
            Engineered by Mark Allan
            <br />
            Produced by norton with Mark Allan
            <br />
          </p>

          <div>
            <iframe
              title="Think About Nothing - norton - SoundCloud"
              width="100%"
              height="300"
              scrolling="no"
              frameborder="no"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/579164910&color=%230066cc&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default NortonMusicPage;



// WEBPACK FOOTER //
// ./src/routes/music/norton-think-about-nothing/NortonMusicPage.js